import OrderDTO from "@/dto/order/OrderDTO";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderMergeSplitStatus from "@/enum/OrderMergeSplitStatus";
import OrderStatus from "@/enum/OrderStatus";
import { isMergeOrder } from "./OrderUtils";

export function selectAllAvailableOrderItems(orderStatus: OrderStatus, orderItems: OrderItemDTO[]) {
    if (!orderItems) {
        return orderItems;
    }

    orderItems.forEach((orderItem) => {
        // 订单状态不为取消订单并且orderItem的状态和订单不一致，默认不选中
        const unSelectable =
            orderStatus !== OrderStatus.CANCELED && orderItem.status && orderStatus !== orderItem.status;

        if (unSelectable) {
            return;
        }

        orderItem.isSelected = true;
    });
}

export function selectOrder(order: OrderDTO) {
    order.isSelected = true;
    order._isPartSelected = false;

    if (order.mergeSplitStatus === OrderMergeSplitStatus.MERGE_PARENT && order.childOrders) {
        order.childOrders.forEach((childOrder) => {
            selectAllAvailableOrderItems(order.status, childOrder.orderItems);

            childOrder.isSelected = isChildOrderShouldBeSelected(childOrder);
            childOrder._isPartSelected = false;
        });
    }

    selectAllAvailableOrderItems(order.status, order.orderItems);
}

export function unselectOrder(order: OrderDTO) {
    order.isSelected = false;
    order._isPartSelected = false;

    order.orderItems?.forEach((orderItem) => {
        orderItem.isSelected = false;
    });

    order.childOrders?.forEach((childOrder) => {
        childOrder.orderItems.map((childOrderItem) => {
            childOrderItem.isSelected = false;
        });

        childOrder.isSelected = false;
        childOrder._isPartSelected = false;
    });
}

export function hasChildOrder(order: OrderDTO, childOrderId: number) {
    return order.childOrders && order.childOrders.some((it) => it.id === childOrderId);
}

/**
 * 子订单未添加【isPartSelected】状态 目前没有业务用到
 */
export function selectChildOrderItem(childOrders: OrderDTO[], orderItemId: any, isSelected: boolean) {
    if (!childOrders) {
        return childOrders;
    }

    childOrders.forEach((childOrder) => {
        const orderItems = childOrder.orderItems;

        if (!orderItems || orderItems?.length === 0) {
            return childOrder;
        }

        orderItems.forEach((orderItem) => {
            if (orderItem.id === orderItemId) {
                orderItem.isSelected = isSelected;
            }
        });

        childOrder.isSelected = isChildOrderShouldBeSelected(childOrder);
    });
}

/**
 * 子订单的选中状态
 * 1.子订单有其中一个商品项被选中
 * 2.无商品项但是子订单的状态不是退款中，待付款，已取消的
 */
export function isChildOrderShouldBeSelected(childOrder: OrderDTO) {
    if (!childOrder.orderItems?.length) {
        return (
            !childOrder.isRefunding && ![OrderStatus.PENDING_PAYMENT, OrderStatus.CANCELED].includes(childOrder.status)
        );
    } else {
        return childOrder.orderItems.some((orderItem) => orderItem.isSelected);
    }
}

export function addIsSelectedToOrderItem(order: OrderDTO, selectedRowKeyMap: Map<string, boolean>) {
    if (isMergeOrder(order)) {
        order.childOrders.map((childOrder) => {
            childOrder.orderItems.map((childOrderItem) => {
                childOrderItem.isSelected = selectedRowKeyMap.get(childOrderItem.originalId);
            });

            childOrder.isSelected = isChildOrderShouldBeSelected(childOrder);
        });
    }

    order.orderItems.map((orderItem: OrderItemDTO) => {
        orderItem.isSelected = selectedRowKeyMap.get(orderItem.originalId);
    });
}
